import { Button } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { CardButtonWrap } from 'components/Card';
import completeIcon from 'static/images/icons/complete.png';
import './style.scss';

const Complete: React.FC = () => {
    const location = useLocation();
    const next = (
        location.state as {
            next: string;
        } | null
    )?.next;

    return (
        <div className="bankcards-auth-complete-root">
            <img className="icon" src={completeIcon} alt="" />
            <h3 className="text-center">{__('We have received your bank information. ')}</h3>
            <p className="desc">
                {__(
                    'Please note that you can submit ACH withdraw request using this bank profile only after we verify it.'
                )}
            </p>
            <CardButtonWrap className="mt-5">
                <Link to={next || '/profile'}>
                    <Button size="large" type="primary">
                        {__('确认')}
                    </Button>
                </Link>
            </CardButtonWrap>
        </div>
    );
};

export default Complete;
